var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLeafIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8393 10.2214L43.6212 18.9202L40.6047 21.9082L43.6212 24.8962L34.8393 33.5949L23.041 21.9082L34.8393 10.2214ZM26.0604 21.9082L34.8393 30.6041L40.6018 24.8962L37.5853 21.9082L40.6018 18.9202L34.8393 13.2122L26.0604 21.9082Z",
    fill: "#7DC142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.698 20.9482H39.7738V22.8867H32.698V20.9482Z",
    fill: "#7DC142"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4466 20.8929C30.9634 20.8929 30.5717 21.2809 30.5717 21.7595C30.5717 22.2382 30.9634 22.6262 31.4466 22.6262C31.9298 22.6262 32.3215 22.2382 32.3215 21.7595C32.3215 21.2809 31.9298 20.8929 31.4466 20.8929ZM29.3263 21.7595C29.3263 20.5996 30.2756 19.6593 31.4466 19.6593C32.6177 19.6593 33.567 20.5996 33.567 21.7595C33.567 22.9195 32.6177 23.8598 31.4466 23.8598C30.2756 23.8598 29.3263 22.9195 29.3263 21.7595Z",
    fill: "#7DC142"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78516 8.69852L18.5672 9.52818e-07L21.5838 2.98787L24.6004 -3.91721e-07L33.3825 8.69852L21.5838 20.3849L9.78516 8.69852ZM21.5838 17.3942L30.3631 8.69852L24.6004 2.9907L21.5838 5.97857L18.5672 2.9907L12.8046 8.69852L21.5838 17.3942Z",
    fill: "#7DC142"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6146 10.8196V3.81081H22.5717V10.8196H20.6146Z",
    fill: "#7DC142"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5588 12.059C20.5588 12.5377 20.9505 12.9257 21.4337 12.9257C21.917 12.9257 22.3087 12.5376 22.3087 12.059C22.3087 11.5804 21.917 11.1924 21.4337 11.1924C20.9505 11.1924 20.5588 11.5804 20.5588 12.059ZM21.4337 14.1593C20.2627 14.1593 19.3134 13.219 19.3134 12.059C19.3134 10.8991 20.2627 9.95881 21.4337 9.95881C22.6048 9.95881 23.5541 10.8991 23.5541 12.059C23.5541 13.219 22.6048 14.1593 21.4337 14.1593Z",
    fill: "#7DC142"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3594 35.3014L24.5773 44L21.5607 41.0121L18.5441 44L9.76204 35.3014L21.5607 23.6151L33.3594 35.3014ZM21.5607 26.6058L12.7815 35.3014L18.5441 41.0093L21.5607 38.0214L24.5773 41.0093L30.3399 35.3014L21.5607 26.6058Z",
    fill: "#7DC142"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5299 33.1804L22.5299 40.1892H20.5728L20.5728 33.1804H22.5299Z",
    fill: "#7DC142"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5857 31.9409C22.5857 31.4623 22.194 31.0743 21.7108 31.0743C21.2275 31.0743 20.8358 31.4623 20.8358 31.9409C20.8358 32.4195 21.2275 32.8075 21.7108 32.8075C22.194 32.8075 22.5857 32.4195 22.5857 31.9409ZM21.7108 29.8407C22.8818 29.8407 23.8312 30.781 23.8312 31.9409C23.8312 33.1009 22.8818 34.0412 21.7108 34.0412C20.5397 34.0412 19.5904 33.1009 19.5904 31.9409C19.5904 30.781 20.5397 29.8407 21.7108 29.8407Z",
    fill: "#7DC142"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78176 33.5721L-5.82309e-05 24.8733L3.01643 21.8853L-5.95884e-05 18.8974L8.78176 10.1986L20.5801 21.8853L8.78176 33.5721ZM17.5607 21.8853L8.78176 13.1894L3.01928 18.8974L6.03577 21.8853L3.01928 24.8733L8.78176 30.5813L17.5607 21.8853Z",
    fill: "#7DC142"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9231 22.8453H3.84725V20.9068H10.9231V22.8453Z",
    fill: "#7DC142"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1745 22.9006C12.6577 22.9006 13.0494 22.5126 13.0494 22.034C13.0494 21.5553 12.6577 21.1673 12.1745 21.1673C11.6913 21.1673 11.2996 21.5553 11.2996 22.034C11.2996 22.5126 11.6913 22.9006 12.1745 22.9006ZM14.2948 22.034C14.2948 23.1939 13.3455 24.1343 12.1745 24.1343C11.0034 24.1343 10.0541 23.1939 10.0541 22.034C10.0541 20.8741 11.0034 19.9337 12.1745 19.9337C13.3455 19.9337 14.2948 20.8741 14.2948 22.034Z",
    fill: "#7DC142"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLeafIcon);
export default __webpack_public_path__ + "static/media/logo-leaf_icon.40014dfc88f46528cb8dc9c729e79026.svg";
export { ForwardRef as ReactComponent };